<template>
  <div class="notif_box">
    <!-- <div :class="typeClass">{{notification.Message}}</div> -->
    <div :class="typeClass">
      <span>{{ notification.Message }}</span>
      <i class="fas fa-times" ></i>
    </div>

    <!-- <button type="button" class="close" data-dismiss="typeClass">×</button> -->
  </div>
</template>

<script>
export default {
  props: {
    notification: Object,
  },
  computed: {
    typeClass() {
      return `alert ${this.notification.type}`;
    },
  },
};
</script>

<style scoped>
.notifications-list .notif_box {
  padding: 20px;
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid #dfe0eb;
  border-radius: 5px 10px 10px 5px;
  overflow: hidden;
}
.notifications-list .notif_box .alert::after {
  content: "";
  width: 5px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.notifications-list .notif_box .alert::before {
  content: "";
  border-radius: 50%;
  font-size: 10px;
  color: #fff;
  height: 26px;
  width: 26px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Font Awesome\ 5 Free";
  position: absolute;
}
.notifications-list .notif_box .alert {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.notifications-list .notif_box .alert span {
  display: flex;
  flex-flow: column;
  padding-left: 15px;
  border-left: 1px solid #dfe0eb;
  color: #8797b0;
  font-size: 12px;
  font-family: Poppins;
  margin-left: 40px;
}
.notifications-list .notif_box .alert span::before {
  content: "";
  font-size: 16px;
  font-weight: 600;
  text-transform: capitalize;
  color: #0c1827;
}
.notifications-list .notif_box .alert.success::before {
  content: "\f00c";
  background-color: #29cc97;
}
.notifications-list .notif_box .alert.success span::before {
  content: "Success!";
}
.notifications-list .notif_box .alert.success::after {
  background: #29cc97;
}

.notifications-list .notif_box .alert.warning::before {
  content: "\f12a";
  background-color: #ffb700;
}
.notifications-list .notif_box .alert.warning span::before {
  content: "Warning!";
}
.notifications-list .notif_box .alert.warning::after {
  background: #ffb700;
}

.notifications-list .notif_box .alert.failure::before {
  content: "\f00d";
  background-color: #c12727;
}
.notifications-list .notif_box .alert.failure span::before {
  content: "Oh Snap!";
}
.notifications-list .notif_box .alert.failure::after {
  background: #c12727;
}

.notifications-list .notif_box .alert.info::before {
  content: "\f129";
  background-color: #3751ff;
}
.notifications-list .notif_box .alert.info span::before {
  content: "Info!";
}
.notifications-list .notif_box .alert.info::after {
  background: #3751ff;
}

.notifications-list .notif_box .alert  i {
  color: #DFE0EB;
  cursor:pointer
} 
@media screen and (max-width: 576px){
  .notifications-list .notif_box[data-v-14f64de0] {
    position: fixed;
    bottom: 20%;
    background: inherit;
    width: 86%;
}
}
</style>
